module.exports = __webpack_public_path__ + "img/glogo207.fb34978a.png";